// "Login with Facebook" integration for the admin back-office, using the
// Facebook JavaScript SDK. FB.login opens a popup (must be called from a user
// gesture) and returns a short-lived access token, which the server verifies
// against the Graph API.

const FB_SDK_URL = "https://connect.facebook.net/en_US/sdk.js";
const FB_APP_ID = process.env.REACT_APP_FB_CLIENT_ID || "";
const FB_GRAPH_VERSION = "v19.0";

let sdkPromise = null;

const loadSdk = () => {
	if (typeof window !== "undefined" && window.FB) {
		return Promise.resolve();
	}
	if (sdkPromise) {
		return sdkPromise;
	}
	sdkPromise = new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = FB_SDK_URL;
		script.async = true;
		script.defer = true;
		script.crossOrigin = "anonymous";
		script.onload = () => {
			window.FB.init({
				appId: FB_APP_ID,
				cookie: true,
				xfbml: false,
				version: FB_GRAPH_VERSION
			});
			resolve();
		};
		script.onerror = () =>
			reject(new Error("Failed to load the Facebook SDK"));
		document.head.appendChild(script);
	});
	return sdkPromise;
};

// Preload the SDK on import so the popup can open from the click gesture.
if (typeof window !== "undefined") {
	loadSdk().catch(() => {});
}

// Opens the Facebook login popup and resolves with { token } (the user access
// token) for the server. Rejects with { status: "cancelled" } when the user
// closes the popup or does not authorize.
export const signInWithFacebook = async () => {
	await loadSdk();
	return new Promise((resolve, reject) => {
		window.FB.login(
			response => {
				if (response && response.authResponse && response.authResponse.accessToken) {
					resolve({ token: response.authResponse.accessToken });
				} else {
					reject({ status: "cancelled" });
				}
			},
			{ scope: "public_profile,email" }
		);
	});
};

export const isFacebookCancel = error =>
	Boolean(error && error.status === "cancelled");
